import Questionaire from '@/Questionaire'

export default [
  {
    path: '/',
    component: Questionaire,
    name: 'Questionaire'
  }
]
